module.exports = __webpack_public_path__ + "static/media/13-14.dcec5c1d.mp3";